import { store } from '@/store/store';
import { VersionBack } from '@/shared/dtos/VersionBack';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'VersionBackModule',
    store,
    dynamic: true
})
class VersionBackModule extends VuexModule {
    public VersionFrontData: VersionBack = new VersionBack();
    public versionback: string = "";
    public versionfront: string = "";
    public versionfrontEnv: string = "";


    @Action({ commit: 'onGetVersionFront' })
    public async getVersionFront() {
        return await ssmHttpService.get(API.VersionBack + '/front', null, false);
    }
    @Action({ commit: 'onSetVersionFront' })
    public async setVersionFront() {
        return await ssmHttpService.post(API.VersionBack + '/front-bump', null);
    }

    // Obtiene la versión formateada del backend: "202601281232" -> "2.6.1.28-12"
    @Action({ commit: 'onGetVersionFrontEnv' })
    public async getVersionFrontEnv() {
        return await ssmHttpService.get(API.VersionBack + '/front-formatted', null, false);
    }

    @Mutation
    public onGetVersionFront(res: VersionBack) {
        this.versionfront = new VersionBack(res).version;
    }

    @Mutation
    public onSetVersionFront(res: any) {
        // El backend devuelve: { "updated": true, "version_raw": "202601281258", "version_front": "2.6.1.28-12" }
        if (res && res.version_raw && res.version_front) {
            this.versionfront = res.version_raw;
            this.versionfrontEnv = res.version_front;
        } else if (res && res.version) {
            // Fallback para formato antiguo
            this.versionfront = new VersionBack(res).version;
        }
    }

    // Guarda la versión formateada recibida del backend
    @Mutation
    public onGetVersionFrontEnv(res: any) {
        // El backend devuelve: { "version_raw": "202601281232", "version_front": "2.6.1.28-12" }
        // Extraemos solo version_front
        this.versionfrontEnv = (res && res.version_front) ? res.version_front : res;
    }

    // Getter para obtener la versión formateada
    public get GetVersionEnv(): string {
        return this.versionfrontEnv || (process.env.VUE_APP_VERSION as string) || "0.0.0";
    }

}
export default getModule(VersionBackModule);